const getFilteredIndexPaths = (url: string, queryParams: QueryParams) => {
    const {
        property_sub_type: propertySubType,
        feature,
        is_retirement_home: isRetirementHomeQryParam
    } = queryParams;
    const numberOfParams = Object.keys(queryParams).length;

    const isTerracedSubType = propertySubType === 'terraced';
    const isBungalowSubType = propertySubType === 'bungalow';
    const isCottageSubType = propertySubType === 'cottage';
    const hasGarden = feature === 'has_garden';
    const hasParkingGarage = feature === 'has_parking_garage';
    const isBungalow = url.includes('/bungalows/');
    const isRetirement = url.includes('/retirement/');
    const isLondonProperty = url.includes('/property/london');
    const isRetirementHome = isRetirementHomeQryParam === 'true';
    const isSale = url.includes('for-sale');

    return (
        (isTerracedSubType && numberOfParams === 2) ||
        (isBungalowSubType && numberOfParams === 2) ||
        (isBungalow && numberOfParams === 1 && isSale) ||
        (isCottageSubType && numberOfParams === 2) ||
        (hasGarden && numberOfParams === 2) ||
        (hasParkingGarage &&
            numberOfParams === 2 &&
            isLondonProperty &&
            isSale) ||
        (isRetirementHome && numberOfParams === 2) ||
        (isRetirement && numberOfParams === 1 && isSale)
    );
};

type QueryParams = {
    property_sub_type?: string | string[];
    feature?: string | string[];
    is_retirement_home?: string | string[];
    search_source?: string | string[];
    property_type?: string | string[];
    'search-path'?: string | string[];
};

const isInvalidSeoKeywordSearch = (
    url: string,
    totalResults: number,
    regularListingCount: number
) => {
    return (
        url.includes('seo_is_keyword_page=1') &&
        (totalResults < 2 || regularListingCount === 1)
    );
};

export const shouldIndexPath = (
    url: string,
    query: QueryParams,
    pageNumber: number,
    regularListingCount: number,
    extendedListingCount: number
) => {
    const emptyResults = regularListingCount === 0;
    const totalResults = regularListingCount + extendedListingCount;

    const { search_source: searchSource } = query;

    if (emptyResults) return false;

    const hasJustFiltered = searchSource === 'facets';
    if (hasJustFiltered) {
        const queryParams = { ...query };
        delete queryParams['search-path'];

        return getFilteredIndexPaths(url, queryParams);
    }

    if (pageNumber > 1 || emptyResults) {
        return false;
    }

    return !isInvalidSeoKeywordSearch(url, totalResults, regularListingCount);
};
